import { useEffect, useState } from 'react'
import { getSubmit } from '@ui-seeker/utils'


const asList = res => (Array.isArray(res) ? res : [])

/** `[{ value, label, … }]` of an options endpoint; `null` while loading; `[]` on failure. Asked once per `url` + params. */
export default function useOptions(url, params = null, { enabled = true } = {}) {
	const key = enabled ? `${url}?${JSON.stringify(params)}` : null
	const [state, setState] = useState({ key: null, options: null })
	useEffect(() => {
		if (!key) return undefined
		let alive = true
		getSubmit(url, params, { retries: 1 })
			.then(res => alive && setState({ key, options: asList(res) }))
			.catch(() => alive && setState({ key, options: [] }))
		return () => { alive = false }
	}, [key])
	return state.key === key ? state.options : null
}
